var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("无数据商品列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.filter
        ? _c(
            "el-row",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "space-around"
              }
            },
            _vm._l(_vm.filter.optionOrigin, function(item) {
              return _c(
                "el-col",
                {
                  key: item.key,
                  staticClass: "column",
                  attrs: { span: 24 / _vm.filter.optionOrigin.length }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "status",
                      class: { active: _vm.origin == item.key },
                      on: {
                        click: function($event) {
                          return _vm.selectStatus(item.key)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.select_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "select_type", $$v)
                                      },
                                      expression: "form.select_type"
                                    }
                                  },
                                  _vm._l(_vm.select_type_option, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入查询的内容" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.select_type_value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "select_type_value",
                                        $$v
                                      )
                                    },
                                    expression: "form.select_type_value"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "代采组" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      multiple: "",
                                      placeholder: "代采组"
                                    },
                                    model: {
                                      value: _vm.form.pgid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pgid", $$v)
                                      },
                                      expression: "form.pgid"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.filter.optionPg, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          value: item.key,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "代采员" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      multiple: "",
                                      placeholder: "代采员"
                                    },
                                    model: {
                                      value: _vm.form.pg_member_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pg_member_id", $$v)
                                      },
                                      expression: "form.pg_member_id"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.filter.optionPgMember, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否拦截" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.is_stop,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_stop", $$v)
                                      },
                                      expression: "form.is_stop"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.filter.optionIsStop, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "状态" },
                                    model: {
                                      value: _vm.form.handle_state,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "handle_state", $$v)
                                      },
                                      expression: "form.handle_state"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.filter.optionHandleState,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            value: item.key,
                                            label: item.label
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "点货类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "点货类型" },
                                    model: {
                                      value: _vm.form.dh_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "dh_type", $$v)
                                      },
                                      expression: "form.dh_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.filter.optionDhType, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "不良品类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "不良品类型" },
                                    model: {
                                      value: _vm.form.blp_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "blp_type", $$v)
                                      },
                                      expression: "form.blp_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.filter.optionBlpType, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    "default-time": ["06:00:00", "06:00:00"],
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "time", $$v)
                                    },
                                    expression: "form.time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "处理时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    "default-time": ["06:00:00", "06:00:00"],
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.handle_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "handle_time", $$v)
                                    },
                                    expression: "form.handle_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "包裹类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "包裹类型"
                                    },
                                    model: {
                                      value: _vm.form.package_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "package_type", $$v)
                                      },
                                      expression: "form.package_type"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "大货", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "备货", value: "2" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "前置仓", value: "3" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否核实" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "是否核实"
                                    },
                                    model: {
                                      value: _vm.form.is_verify,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_verify", $$v)
                                      },
                                      expression: "form.is_verify"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "是", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "否", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退还方式" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "退还方式"
                                    },
                                    model: {
                                      value: _vm.form.return_mode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "return_mode", $$v)
                                      },
                                      expression: "form.return_mode"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "0" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "市场退回", value: "1" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "快递寄回", value: "2" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退还快递单号" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "快递单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.shipping_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipping_num", $$v)
                                    },
                                    expression: "form.shipping_num"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.stopRows(0)
                          }
                        }
                      },
                      [_vm._v("\n            批量拦截/不拦截")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.showNdgDialog(1)
                          }
                        }
                      },
                      [_vm._v("\n            移交代采")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.showNdgDialog(2)
                          }
                        }
                      },
                      [_vm._v("\n            放行退还打包")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            _vm.recall_dialog = true
                          }
                        }
                      },
                      [_vm._v("\n            撤回包裹号\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.showReturnShippingModal }
                      },
                      [_vm._v("\n            填写退还快递单号\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.handleBatchWithdraw }
                      },
                      [_vm._v("\n            批量撤回放行退还\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading"
                      }
                    ],
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      height: "600",
                      data: _vm.resData.list,
                      "tooltip-effect": "dark",
                      border: ""
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", type: "selection" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ndgid",
                        label: "无数据标id",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_no",
                        label: "批次单",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "package_no",
                        label: "包裹号",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "package_type",
                        label: "包裹类型",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supply_name",
                        label: "商家",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pg_member_name",
                        label: "代采员",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "no_data_reason_text",
                        label: "无数据理由",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "admin_name",
                        label: "创建人",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "create_time",
                        label: "创建时间",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "note",
                        label: "备注",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_state_text",
                        label: "状态",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "is_verify_text",
                        label: "是否核实",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "verify_text",
                        label: "核实信息",
                        align: "center",
                        width: "150"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return row.verify_text
                                ? [
                                    _c("el-tooltip", [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        _vm._l(
                                          row.verify_text.split("\n"),
                                          function(text) {
                                            return _c("div", { key: text }, [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(text) +
                                                  "\n                  "
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        _vm._l(
                                          row.verify_text.split("\n"),
                                          function(text) {
                                            return _c(
                                              "div",
                                              {
                                                key: text,
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(text) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ]
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "image_turn_over_arr",
                        label: "移交代采图片(多图)",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              row.image_turn_over_arr[0]
                                ? _c("img", {
                                    staticStyle: {
                                      width: "80px",
                                      height: "80px"
                                    },
                                    attrs: {
                                      src: row.image_turn_over_arr[0],
                                      alt: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleViewImages(
                                          row.image_turn_over_arr
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "dbid",
                        label: "打标id",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_admin_name",
                        label: "处理人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "dh_type",
                        label: "点货类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "blp_type",
                        label: "不良品类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "blp_note",
                        label: "不良品备注",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "invalid_note",
                        label: "作废理由",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_time",
                        label: "处理时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "return_mode_str",
                        label: "退还方式",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "return_note",
                        label: "退还备注",
                        align: "center",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "快速寄回收件信息", width: "200px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "white-space": "pre-line" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        scope.row.return_express_info
                                          ? scope.row.return_express_info
                                          : "-"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "no_data_package_no",
                        label: "无数据包裹号",
                        align: "center",
                        width: "160px"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "package_img_arr",
                        label: "包裹图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              row.package_img_arr[0]
                                ? _c("img", {
                                    staticStyle: {
                                      width: "80px",
                                      height: "80px"
                                    },
                                    attrs: {
                                      src: row.package_img_arr[0],
                                      alt: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleViewImages(
                                          row.package_img_arr
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "shipping_num",
                        label: "退还快递单号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "signing_time",
                        label: "签收时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "signing_name",
                        label: "签收人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "signing_phone",
                        label: "签收手机号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "buyer_datetime",
                        label: "提交代采时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "return_datetime",
                        label: "提交退还时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "verify_time",
                        label: "代采核实时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "withdraw_time",
                        label: "撤回退还时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pack_datetime",
                        label: "退还打包时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        align: "center",
                        fixed: "right",
                        width: "200px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  disabled: !["1", "2"].includes(
                                    scope.row.handle_state
                                  ),
                                  "active-value": "1",
                                  "inactive-value": "2",
                                  "active-text": "拦截",
                                  "inactive-text": "不拦截"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.stopRow(scope.$index)
                                  }
                                },
                                model: {
                                  value: scope.row.is_stop,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "is_stop", $$v)
                                  },
                                  expression: "scope.row.is_stop"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "text",
                                    disabled: !["1", "2"].includes(
                                      scope.row.handle_state
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.discard(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("做废")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.form.page,
                        "page-size": _vm.form.page_size,
                        background: "",
                        layout: "total, prev, pager, next, jumper, sizes",
                        total: _vm.resData.count,
                        "page-sizes": [50, 100, 200, 500]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.form, "page", $event)
                        },
                        "update:pageSize": function($event) {
                          return _vm.$set(_vm.form, "page_size", $event)
                        },
                        "update:page-size": function($event) {
                          return _vm.$set(_vm.form, "page_size", $event)
                        },
                        "current-change": _vm.fetchData,
                        "size-change": function(size) {
                          _vm.form.page_size = size
                          _vm.search()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.ndg_dialog.show,
            title:
              _vm.ndg_dialog.type === _vm.ConstEnum.transfer
                ? "无数据移交代采"
                : "无数据商品——放行退还打包",
            width: "660px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ndg_dialog, "show", $event)
            },
            close: _vm.clearRecallList
          }
        },
        [
          [
            _vm.ndg_dialog.type === _vm.ConstEnum.sendBack &&
            _vm.supplyInfo.supply_name
              ? _c("H4", [
                  _vm._v("商家名称：" + _vm._s(_vm.supplyInfo.supply_name))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.ndg_dialog.type === _vm.ConstEnum.sendBack &&
            _vm.supplyInfo.return_mode_text
              ? _c("H4", [
                  _vm._v("退还方式：" + _vm._s(_vm.supplyInfo.return_mode_text))
                ])
              : _vm._e()
          ],
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c("el-input", {
                    ref: "scanNdgidRef",
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "扫描/输入无数据ID" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.scanPush.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.ndg_dialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ndg_dialog, "value", $$v)
                      },
                      expression: "ndg_dialog.value"
                    }
                  }),
                  _vm._v("   \n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.scanPush }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.ndg_dialog.type === _vm.ConstEnum.transfer
                            ? _c(
                                "el-upload",
                                {
                                  attrs: {
                                    "before-upload": _vm.beforeImport,
                                    "on-success": _vm.handleImport,
                                    action: _vm.action,
                                    "show-file-list": false,
                                    "with-credentials": ""
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "success" } },
                                    [_vm._v("导入")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.ndg_dialog.type === _vm.ConstEnum.transfer ||
          _vm.ConstEnum.sendBack
            ? [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.ndg_dialog.scan,
                      border: "",
                      "max-height": "400",
                      "row-class-name": _vm.tableRowClassName
                    }
                  },
                  [
                    _vm._v(">\n        "),
                    _c("el-table-column", {
                      attrs: {
                        label: "无数据ID",
                        prop: "ndgid",
                        align: "center",
                        width: "100px"
                      }
                    }),
                    _vm._v(" "),
                    _vm.ndg_dialog.type === _vm.ConstEnum.transfer
                      ? _c("el-table-column", {
                          attrs: {
                            label: "上传图片（至少一张，最多五张）",
                            prop: "images",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  var $index = ref.$index
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer",
                                            value: row.images,
                                            expression: "row.images"
                                          }
                                        ],
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row"
                                        }
                                      },
                                      [
                                        _vm._l(row.images, function(item, i) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.name,
                                              staticStyle: {
                                                position: "relative",
                                                width: "60px",
                                                height: "60px",
                                                margin: "4px"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%"
                                                },
                                                attrs: {
                                                  src: item.url,
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-circle-close",
                                                staticStyle: {
                                                  position: "absolute",
                                                  top: "-4px",
                                                  right: "-4px",
                                                  "font-size": "14px",
                                                  color: "red"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDelImages(
                                                      $index,
                                                      i
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              width: "60px",
                                              height: "60px",
                                              margin: "4px",
                                              display: "inline-flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                              border: "1px solid #ccc"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleEditImages(
                                                  row,
                                                  $index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus"
                                            })
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1444279038
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ndg_dialog.type === _vm.ConstEnum.sendBack
                      ? _c("el-table-column", {
                          attrs: {
                            label: "图片",
                            prop: "images",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer",
                                            value: row.images,
                                            expression: "row.images"
                                          }
                                        ],
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row"
                                        }
                                      },
                                      _vm._l(row.images, function(item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.name,
                                            staticStyle: {
                                              position: "relative",
                                              width: "60px",
                                              height: "60px",
                                              margin: "4px"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: item.url, alt: "" }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            317095774
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        prop: "actions",
                        align: "center",
                        width: "80px"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var $index = ref.$index
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleRemoveNoData($index)
                                      }
                                    }
                                  },
                                  [_vm._v("移除")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4277606587
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ndg_dialog.type === _vm.ConstEnum.sendBack
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { margin: "10px 0 20px", float: "right" },
                        attrs: { size: "small" },
                        on: { click: _vm.clearRecallList }
                      },
                      [_vm._v("重置当前退还列表数据")]
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "primary",
                    disabled: _vm.ndg_dialog.scan.length === 0
                  },
                  on: { click: _vm.toDealNdg }
                },
                [
                  _vm._v(
                    "确定" +
                      _vm._s(
                        _vm.ndg_dialog.type === _vm.ConstEnum.transfer
                          ? "移交"
                          : "退还"
                      ) +
                      "\n        (共" +
                      _vm._s(_vm.ndg_dialog.scan.length) +
                      "件)"
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.stop_dialog.show,
            "close-on-click-modal": false,
            title: "提示",
            width: "300px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.stop_dialog, "show", $event)
            }
          }
        },
        [
          _c("div", [_vm._v(_vm._s(_vm.stop_dialog.msg))]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "40px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.stopRows(1, 1)
                    }
                  }
                },
                [_vm._v("拦截")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.stopRows(1, 2)
                    }
                  }
                },
                [_vm._v("不拦截")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.recall_dialog,
            "close-on-click-modal": false,
            title: "撤回包裹号",
            width: "300px"
          },
          on: {
            "update:visible": function($event) {
              _vm.recall_dialog = $event
            }
          }
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入包裹号" },
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleRecall.apply(null, arguments)
              }
            },
            model: {
              value: _vm.noDataPackageNo,
              callback: function($$v) {
                _vm.noDataPackageNo = $$v
              },
              expression: "noDataPackageNo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("ys-camera", {
        attrs: { limit: _vm.ConstEnum.limitImage, list: _vm.curItem.images },
        on: { complete: _vm.handleConfirmImages },
        model: {
          value: _vm.isShowModalImages,
          callback: function($$v) {
            _vm.isShowModalImages = $$v
          },
          expression: "isShowModalImages"
        }
      }),
      _vm._v(" "),
      _c("ys-camera", {
        attrs: {
          limit: _vm.ConstEnum.backLimitImage,
          "show-close": true,
          "is-show-close-btn": false,
          title: "退还包裹拍照（限1张）",
          "camera-type": 2
        },
        on: { complete: _vm.handleConfirmBackImages },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("div", [
                  _c("p", [_vm._v("商家：" + _vm._s(_vm.supplyName))]),
                  _vm._v(" "),
                  _c("p", [_vm._v("包裹号：" + _vm._s(_vm.noDataPackNo))])
                ])
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.isShowModalPhotos,
          callback: function($$v) {
            _vm.isShowModalPhotos = $$v
          },
          expression: "isShowModalPhotos"
        }
      }),
      _vm._v(" "),
      _c("lodop-print-for-no-data-package", {
        ref: "printForNoDataPackageRef"
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.returnShippingModalVisible,
            "close-on-click-modal": true,
            title: "填写退还快递单号",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.returnShippingModalVisible = $event
            },
            close: _vm.handleReturnShippingModalClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "returnShippingFormRef",
              attrs: {
                inline: "",
                model: _vm.returnShippingForm,
                rules: _vm.shippingFormRules,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "无数据包裹号", prop: "package_no" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "扫描/输入无数据包裹号" },
                    on: {
                      change: _vm.fetchNoDataInfoByPackageNo,
                      input: function($event) {
                        _vm.returnShippingForm.shipping_num = ""
                      }
                    },
                    model: {
                      value: _vm.returnShippingForm.package_no,
                      callback: function($$v) {
                        _vm.$set(_vm.returnShippingForm, "package_no", $$v)
                      },
                      expression: "returnShippingForm.package_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家名称", prop: "supply_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", readonly: "", disabled: "" },
                    model: {
                      value: _vm.returnShippingForm.supply_name,
                      callback: function($$v) {
                        _vm.$set(_vm.returnShippingForm, "supply_name", $$v)
                      },
                      expression: "returnShippingForm.supply_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "退还方式", prop: "return_mode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "", readonly: "", disabled: "" },
                    model: {
                      value: _vm.returnShippingForm.return_mode,
                      callback: function($$v) {
                        _vm.$set(_vm.returnShippingForm, "return_mode", $$v)
                      },
                      expression: "returnShippingForm.return_mode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "退还快递单号", prop: "shipping_num" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写快递单号" },
                    model: {
                      value: _vm.returnShippingForm.shipping_num,
                      callback: function($$v) {
                        _vm.$set(_vm.returnShippingForm, "shipping_num", $$v)
                      },
                      expression: "returnShippingForm.shipping_num"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "40px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: { click: _vm.handleReturnShippingModalClose }
                },
                [_vm._v("\n        取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleReturnShipping }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.batchWithdrawDialog,
            "close-on-click-modal": false,
            title: "撤回放行退还",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.batchWithdrawDialog = $event
            }
          }
        },
        [
          _c("div", [
            _vm._v(
              "\n      已选中" +
                _vm._s(_vm.batchWithdrawArr.length) +
                "件无数据商品，请确认是否撤回至代采待处理？\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "40px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      _vm.batchWithdrawDialog = false
                    }
                  }
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitBatchWithdraw }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.checkTipsDialog,
            "close-on-click-modal": false,
            title: "",
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.checkTipsDialog = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.noPassCheckIds))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "4px", "font-size": "16px" } },
            [_vm._v("\n      为非待放行退还状态，不可撤回\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "40px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.checkTipsDialog = false
                    }
                  }
                },
                [_vm._v("\n        确定\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daec93de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daec93de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/nodatagoods/NoDataGoodsList.vue
// module id = null
// module chunks = 